import React, { useContext } from "react";
import { MachineContext } from "../fsm/useMachine";
import { NewMmoButton } from "./NewMmoButton";
import Popup from "reactjs-popup";
import { AddUrl } from "./WebModal";
import ShapeMenu from "./ShapeMenu";
import BackgroundMenu from "./BackgroundMenu";
import { ControlledPopup } from "../popups/Controlled";
import { Spacer } from "./Spacer";
import { Export } from "./ExportButton";
import { useCookies } from "../utils/useCookies";
import UploadModal from "./uploadModal";
import { ColorPicker } from "../view/ColorPicker";
import LocationControls from "./LocationControls";
import TextFlowObject from "../../model/TextFlowObject";
import { ADD_MMO, SET_CURRENT_OBJECT, CHANGE_TITLE, REORDER_MMOS, FlowObjects, UNDO, REDO } from "../fsm/types";
import { addImageHelper, addVideoHelper, addPdfHelper } from "./adding";
import MediaControls from "./MediaControls";
import TextControls from "./TextControls";
import { OrderShift } from "../../model/Screens";
import { GalleryPicker } from "./Gallery";
import { ViewMenu } from "./ViewMenu";
import Settings from "./settings";
// import * as filestack from 'filestack-js';
// @ts-ignore // No types file included.
import DropboxChooser from "react-dropbox-chooser";
import { string_id } from "../utils/getInfo";
import {
    Video,
    Volume2,
    Image,
    PlayCircle,
    XCircle,
    Share,
    UploadCloud,
    CornerDownLeft,
    CornerUpRight,
    HelpCircle,
    Youtube,
    Type,
    Printer,
    Info,
} from "react-feather";
import PdfIcon from "../icons/PdfIcon";
import DropboxIcon from "../icons/DropboxIcon";
import { StageBoundsType } from "../root/listeners";
import { useSnackbar } from 'notistack';




export const Controls: React.FC<{
    setShowTutorial: React.Dispatch<React.SetStateAction<boolean>>,
    size: StageBoundsType,
    hasContentLayer: boolean,
    isThemePickerOpen: boolean,
    setIsThemePickerOpen: React.Dispatch<React.SetStateAction<boolean>>,
    currentThemeId?: string,
    isMobilePreviewOpen?: boolean,
    setIsMobilePreviewOpen?: React.Dispatch<React.SetStateAction<boolean>>,
}> = ({ setShowTutorial, size, hasContentLayer, isThemePickerOpen, setIsThemePickerOpen, currentThemeId, isMobilePreviewOpen, setIsMobilePreviewOpen }) => {
    let [current, send] = useContext(MachineContext);
    const [,] = useCookies();
    const { enqueueSnackbar } = useSnackbar();
    // const client = filestack.init('Am4HtX5MQgmSQHjGKzXZAz');


    const addTextItem = () => {
        const newText = TextFlowObject.default();
        newText.frame.x = (current.context.flow.viewSize.width / 2 - newText.frame.width / 2);
        newText.frame.y = (current.context.flow.viewSize.height / 2 - newText.frame.height / 2);
        newText.frame.y = newText.frame.y - 10;        
        send([{ type: ADD_MMO, mmo: newText, screenIndex:current.context.index }])        
        console.log("firing text")
    };

    const addImage = async (e: React.ChangeEvent<HTMLInputElement>) => {
        e.preventDefault();
        if (e.target.files!.length > 0) {
            let file = e.target.files![0];
       
            enqueueSnackbar(`Image added ...`, { autoHideDuration: 2500, persist: false })
            addImageHelper(file, current.context.flow.viewSize, send, current.context.index)
        }
    };

    const addPdf = async (e: React.ChangeEvent<HTMLInputElement>) => {
        e.preventDefault();
        let file = e.target.files![0];
        enqueueSnackbar(`PDF added ...`, { autoHideDuration: 2500, persist: false })
        addPdfHelper(file, current.context.flow.viewSize, send, current.context.index)
    };

    const addVideo = async (e: React.ChangeEvent<HTMLInputElement>) => {
        e.preventDefault();
        let file = e.target.files![0];
        if (isVideo(file.name)) {
            enqueueSnackbar(`Video added ...`, { autoHideDuration: 2500, persist: false })
            addVideoHelper(file, current.context.flow.viewSize, send, current.context.index)
        } else {
            alert("We only support mp4 file format currently.");
        }
    };

    const isVideo = (filename: string) => {
        var parts = filename.split(".");
        var ext = parts[parts.length - 1];
        switch (ext.toLowerCase()) {
            case "mp4":
                // etc
                return true;
        }
        console.log("false");
    };

    const addAudio = () => {
        alert("Audio is not quite ready here, but coming soon!");
    };

    const updateTitle = (e: React.ChangeEvent<HTMLInputElement>) => {
        e.stopPropagation();
        send({ type: CHANGE_TITLE, text: e.currentTarget.value })
    };


    const sendOrderChange = (order: OrderShift) => {
        send({ type: REORDER_MMOS, direction: order, id: current.context.currentObject!.id })
    };

    // const addCloud = async () => {

    //     const options = {
    //         maxFiles: 20,
    //         fromSources: ["dropbox", "instagram", "facebook", "googledrive", "onedrive"],
    //         accept: ["image/*", ".pdf", ".mp4"],
    //         uploadInBackground: false,
    //         onOpen: () => console.log('opened!'),
    //         onUploadDone: async (res: any) => {

    //             for (let file of res.filesUploaded) {
    //                 file.type = file.mimetime;

    //                 let fileObj = await fetch(file.url)
    //                     .then(r => r.blob())
    //                     .then(r => new File([r], file.filename, {
    //                         type: file.mimetype,
    //                     }));

    //                 console.log('fileObj : ', fileObj);
    //                 addFile(fileObj, file.name)
    //             }
    //         },
    //     };
    //     client.picker(options).open();
    // };
    const addDropbox = async (dropFiles: any) => {
        for (let file of dropFiles) {
            console.log("FILE", file);


            const proxyurl = "https://cors-anywhere.herokuapp.com/";
            const url = file.link.replace("www.dropbox.com", "dl.dropboxusercontent.com");

            let fileObj = await fetch(url, {
                method: 'GET',
                mode: 'cors',
                cache: 'no-cache',
                credentials: 'same-origin',
                headers: {},
                referrer: 'no-referrer',
            })
                .then(r => r.blob())
                .then(r => new File([r], file.filename, {
                    type: r.type,
                })
                );

            console.log('fileObj : ', fileObj);
            addFile(fileObj, file.name)
        }
    };

    const addFile = (fileObj: File, name: string) => {
        if (fileObj.type == "video/mp4") {

            console.log("VIDEO")
            addVideoHelper(fileObj, current.context.flow.viewSize, send, current.context.index)
        } else if (fileObj.type == "application/pdf") {

            console.log("PDF")
            addPdfHelper(fileObj, current.context.flow.viewSize, send, current.context.index)
        } else if (fileObj.type == "image/png" || fileObj.type == "image/jpeg") {

            console.log("IMAGE")
            addImageHelper(fileObj, current.context.flow.viewSize, send, current.context.index)
        } else {

            console.log("No Media")
        }
    };

    const { currentObject, flow } = current.context;

    return (
        
        <div>
            <div id="control_panel">
                <div className="control" style={{ position: 'relative' }}>
                    <div style={{ display: 'flex', alignItems: 'center', flexShrink: 0 }}>
                        <div
                            id="add_items"
                            className="add_items"
                        >
                            <div className="div_styles add_buttons" title="Add Text">
                            <Type className="feather" onClick={addTextItem} />
                            <span>Text</span>
                            </div>
                            <NewMmoButton
                                name="Image"
                                // @ts-ignore
                                handler={addImage}
                                accepts=".png,.gif,.jpg,.jpeg"
                                title="Add Image"
                            >
                                <Image className="feather" />
                            </NewMmoButton>
                            <GalleryPicker showTitle={true} />
                            <NewMmoButton
                                name="Video"
                                // @ts-ignore
                                handler={addVideo}
                                accepts=".mp4,.mov"
                                title="Add Video"
                            >
                                <Video className="feather" />
                            </NewMmoButton>
                            <Popup className="addYouTube"
                                trigger={
                                    <div className="div_styles" title={"Add YouTube Video"}>
                                        <label>
                                            <Youtube className="feather" />
                                        </label>
                                        <span>YouTube</span>
                                    </div>
                                } modal closeOnDocumentClick>
                                {(close: () => void) => <AddUrl isYoutube={true} close={close} />}
                            </Popup>
                            <div
                                className="div_styles add_buttons"
                                title="Add MP3"
                                onClick={addAudio}
                            >
                                <Volume2 className="feather" />
                                <span>Audio</span>
                            </div>
                            <NewMmoButton
                                name="PDF"
                                // @ts-ignore
                                handler={addPdf}
                                accepts="application/pdf, .pdf"
                                title="Add PDF"
                            >
                                <PdfIcon />
                            </NewMmoButton>
                            <ShapeMenu />
                        {/* Dropbox button temporarily disabled
                        &nbsp;
                        <DropboxChooser
                                appKey={'mt1y1925trbkth8'}
                                success={(files: any) => addDropbox(files)}
                                multiselect={false}
                                extensions={['.mp4,.jpg,.png,.pdf,.gif']} >
                                <div className="div_styles" title={"Add From Drobox"} style={{ marginTop: "-3px" }}>
                                    <label>
                                        <DropboxIcon />
                                    </label>
                                    <span>Dropbox</span>
                                </div>
                            </DropboxChooser>
                        */}
                        </div>
                        <div id="background_items" style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            marginLeft: 4,
                            border: '1px solid rgba(128,128,128,0.5)',
                            borderRadius: 8,
                            padding: '0px 8px',
                            height: 42,
                            boxSizing: 'border-box' as const,
                            minWidth: 64,
                        }}>
                            <BackgroundMenu />
                        </div>
                    </div>
                    <div id="preview_flow_buttons"
                        className="flex_third_center"
                        style={{ position: 'absolute', left: '50%', transform: 'translateX(-50%)', zIndex: 1 }}
                    >
                        <Popup
                            trigger={
                                <div className="preview_flow div_styles" title="Preview Flow">
                                    <label>
                                        <PlayCircle className={"feather play"} />
                                    </label>
                                    <span >View</span>
                                </div>
                            }
                            on="click"
                            position="bottom center"
                            className="view"
                            closeOnDocumentClick={true}
                            closeOnEscape={false}
                            contentStyle={{ overflow: 'visible', maxHeight: 'none' }}
                            arrowStyle={{}}
                        >
                            {(close: () => void) =>
                                <ViewMenu close={close}
                                    render={(setArgs, setShowModal) => (
                                        <div className="viewButtonClass">
                                            <div className="view-modal-header">
                                                <span>View Options</span>
                                                <XCircle className="feather close-icon" onClick={close} />
                                            </div>
                                            <div className="view-modal-buttons">
                                                <a className="view-modal-button" title="View your currently published version" href={`/s/${string_id}`}>
                                                    <strong>View Published Version</strong>
                                                    <span className="view-modal-subtitle">See what's live now</span>
                                                </a>
                                                <button className="view-modal-button" onClick={() => {
                                                    setArgs({ asDraft: false, forceToView: false })
                                                    setShowModal(true)
                                                }} title="Post this version and then view it">
                                                    <strong>Post and View</strong>
                                                    <span className="view-modal-subtitle">Publish changes and preview</span>
                                                </button>
                                                <button className="view-modal-button" onClick={() => {
                                                    setArgs({ asDraft: true, forceToView: true })
                                                    setShowModal(true)
                                                }} title="Save a draft and then view this draft version">
                                                    <strong>Save Draft and View</strong>
                                                    <span className="view-modal-subtitle">Preview without publishing</span>
                                                </button>
                                                <button className="view-modal-button view-modal-cancel" onClick={close}>Cancel</button>
                                            </div>
                                        </div>)}
                                />
                            }
                        </Popup>
                        <input
                            type="text"
                            onFocus={() => send({ type: "MARK_ACTIVE", id: "title" })}
                            onBlur={() => send({ type: "MARK_INACTIVE" })}
                            onChange={updateTitle}
                            defaultValue={flow.title}
                            className="input"
                        />
                        <Popup
                            trigger={
                                <button className="post" title="Post">
                                    <Share className="feather" width="15" />
                                    <span>Post</span>
                                </button>
                            }
                            on="click"
                            modal
                            closeOnDocumentClick={false}
                            closeOnEscape={false}
                        >
                            {(close: () => void) => {
                                return (
                                    <UploadModal
                                        publishArgs={{ asDraft: false, forceToView: false }}
                                        close={close}
                                    />
                                );
                            }}
                        </Popup>
          &nbsp;
          <ControlledPopup
                            trigger={
                                <div
                                    title="Save Draft"
                                    className="clear_button div_styles"
                                >
                                    <label>
                                        <UploadCloud className="feather" />
                                    </label>
                                    <span >Save Draft</span>
                                </div>
                            }
                            on="click"
                            modal
                            closeOnDocumentClick={false}
                        >
                            {(close: () => void) => {
                                return (
                                    <UploadModal
                                        publishArgs={{ asDraft: true, forceToView: false }}
                                        close={close}
                                    />
                                );
                            }}
                        </ControlledPopup>
                        <Popup
                            trigger={
                                <button className="empty" title="Flow Info" style={{ minWidth: '36px' }}>
                                    <Info className="feather" width="18" />
                                </button>
                            }
                            position="bottom center"
                            closeOnDocumentClick={true}
                            className="flow-info-popup"
                        >
                            {(close: () => void) => {
                                if (!flow) {
                                    return <div>Loading...</div>;
                                }
                                return (
                                    <div className="flow-info-modal">
                                        <XCircle className="feather flow-info-close" onClick={close} />
                                        <h3 style={{ margin: '0 0 12px 0', fontSize: '16px' }}>Flow Info</h3>
                                        <div style={{ marginBottom: '10px', fontSize: '14px' }}>
                                            <strong>Title:</strong> {flow?.title || 'Untitled'}
                                        </div>
                                        <div style={{ marginBottom: '10px', fontSize: '14px' }}>
                                            <strong>URL:</strong><br/>
                                            <a href={`/s/${string_id}`} target="_blank" rel="noopener noreferrer" style={{ fontSize: '12px', wordBreak: 'break-all' }}>
                                                {window.location.origin}/s/{string_id}
                                            </a>
                                        </div>
                                        <div style={{ marginBottom: '10px', fontSize: '14px' }}>
                                            <strong>Description:</strong> {flow?.description || '(No description)'}
                                        </div>
                                        <div style={{ fontSize: '14px' }}>
                                            <strong>Screens:</strong> {flow?.screens?.length || 0}
                                        </div>
                                    </div>
                                );
                            }}
                        </Popup>
                    </div>
                    <div id="flex_third_center" className="flex_third_center" style={{ marginLeft: 'auto', display: 'flex', alignItems: 'center' }} >
                        {setIsMobilePreviewOpen && (
                            <button
                                className={`control-bar-theme-btn ${isMobilePreviewOpen ? 'active' : ''}`}
                                onClick={() => setIsMobilePreviewOpen(prev => !prev)}
                                title="Mobile Preview"
                                style={{ marginLeft: 0, marginRight: 10 }}
                            >
                                <svg viewBox="0 0 24 24" width="20" height="20">
                                    <path fill="currentColor" d="M15.5 1h-8A2.5 2.5 0 0 0 5 3.5v17A2.5 2.5 0 0 0 7.5 23h8a2.5 2.5 0 0 0 2.5-2.5v-17A2.5 2.5 0 0 0 15.5 1zm-4 21c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm4.5-4H7V4h9v14z"/>
                                </svg>
                                <span>Mobile</span>
                            </button>
                        )}
                        {hasContentLayer && (
                            <button
                                className={`control-bar-theme-btn ${isThemePickerOpen ? 'active' : ''}`}
                                onClick={() => setIsThemePickerOpen(prev => !prev)}
                                title="Change Theme"
                                style={{ marginLeft: 0, marginRight: 12 }}
                            >
                                <svg viewBox="0 0 24 24" width="24" height="24">
                                    <path fill="currentColor" d="M12 3c-4.97 0-9 4.03-9 9s4.03 9 9 9c.83 0 1.5-.67 1.5-1.5 0-.39-.15-.74-.39-1.01-.23-.26-.38-.61-.38-.99 0-.83.67-1.5 1.5-1.5H16c2.76 0 5-2.24 5-5 0-4.42-4.03-8-9-8zm-5.5 9c-.83 0-1.5-.67-1.5-1.5S5.67 9 6.5 9 8 9.67 8 10.5 7.33 12 6.5 12zm3-4C8.67 8 8 7.33 8 6.5S8.67 5 9.5 5s1.5.67 1.5 1.5S10.33 8 9.5 8zm5 0c-.83 0-1.5-.67-1.5-1.5S13.67 5 14.5 5s1.5.67 1.5 1.5S15.33 8 14.5 8zm3 4c-.83 0-1.5-.67-1.5-1.5S16.67 9 17.5 9s1.5.67 1.5 1.5-.67 1.5-1.5 1.5z"/>
                                </svg>
                                <span>Theme</span>
                            </button>
                        )}
                        <button className="empty" title="Undo"
                            disabled={current.context.undoStack.length === 0}
                            onClick={(e) => {
                                e.preventDefault()
                                e.stopPropagation()
                                send({ type: UNDO })
                            }}>
                            <CornerDownLeft className="feather" />
                        </button>
                        <Spacer width={3} height={39} />
                        <button className="empty" title="Redo"
                            disabled={current.context.redoStack.length === 0}
                            onClick={(e) => {
                                e.preventDefault()
                                e.stopPropagation()
                                send({ type: REDO })
                            }}>
                            <CornerUpRight className="feather" />
                        </button>
                        <Spacer width={12} height={39} />
                        <button className="empty" title="Help" onClick={() => setShowTutorial(n => !n)}>
                            <HelpCircle className="feather" />
                        </button>
                        <Spacer width={6} height={39} />
                        <Export />
                        <Spacer width={6} height={39} />
                        <Settings />
                    </div>
                </div>
                <div className="panel" >
                    <div className="flex" >
                        <Spacer width={10} height={39} />
                        {currentObject?.type == "gallery" && (
                            <GalleryPicker showTitle={false} />
                        )}
                        {currentObject?.type == "text" && (
                            <TextControls size={size} />
                        )}
                        {(currentObject?.type == "text" ||
                            currentObject?.type == "shape") && (
                                <ColorPicker />
                            )}
                        {currentObject && (
                            <MediaControls
                                sendOrderChange={sendOrderChange}
                            />
                        )}
                    </div>
                    {currentObject && <LocationControls currObject={currentObject} />}
                </div>
            </div>
            <div className="ribbon"><span>&beta;ETA</span></div>
        </div>
    );
};

Controls.displayName = "Controls";
export default Controls;
